import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { nowPartConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const PartStack = createStackNavigator();

const PartNavigator = () => {
  return (
    <PartStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {nowPartConfig.map(({ Component, name }) => (
        <PartStack.Screen key={name} name={name} component={Component} />
      ))}
    </PartStack.Navigator>
  );
};

export { PartNavigator };
